import { render, staticRenderFns } from "./JscConfigurationList.vue?vue&type=template&id=481e0c4b&"
import script from "./JscConfigurationList.vue?vue&type=script&lang=js&"
export * from "./JscConfigurationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports